window.addEventListener("load", function () {
  const links = document.querySelectorAll("#pdp-menu a");
  const sections = document.querySelectorAll("main section");
  const validSections = [];
  const header = document.getElementById('shopify-section-navbar');
  const headerHeight = header.clientHeight;
  const menu = document.getElementById('pdp-menu');
  const reviewsSection = document.getElementById('yotpo-reviews-main-widget');

  sections.forEach(section => {
    if (Array.from(links).find(link => link.dataset.sectionId === section.id)) {
      validSections.push(section);
    }
  });

  function setActiveLink() {
    let currentSectionId = null;

    validSections.forEach((section) => {
      const sectionTop = section.offsetTop;

      if (window.scrollY >= reviewsSection.offsetTop - headerHeight) {
        currentSectionId = "reviews";
      } else if (window.scrollY >= sectionTop - headerHeight) {
        currentSectionId = section.getAttribute("id");
      }
    });

    if (currentSectionId) {
      links.forEach(item => {
        item.classList.remove("active");
        if (item.getAttribute("data-section-id") === currentSectionId) {
          item.classList.add("active");
        }
      });

      // Adjust horizontal scroll to show active link
      const activeLink = document.querySelector("#pdp-menu a.active");
      if (activeLink) {
        menu.scrollLeft = activeLink.offsetLeft - menu.offsetWidth / 2; 
      }
    }
  }

  function scrollToSection(targetSectionId) {
    const targetSection = document.getElementById(targetSectionId);

    if (targetSection) {
      window.scrollTo({
        top: targetSection.offsetTop - headerHeight,
        behavior: "smooth",
      });
    } else {

      window.scrollTo({
        top: reviewsSection.offsetTop - headerHeight,
        behavior: "smooth",
      });
    }
  }

  window.addEventListener("scroll", setActiveLink);

  links.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();

      const targetSectionId = this.dataset.sectionId;

      scrollToSection(targetSectionId);
    });
  });
});
